import './styles.scss';

import { ComponentProps, ReactElement } from 'react';

import InvoicePdfTotalRow from '@/features/PdfLayout/layouts/Invoice/InvoicePdfTotals/InvoicePdfTotalsRow';
import { RunPreviewInvoiceResponse } from '@/models/gen/graphql';
import Table from '@/common/Table';
import { getClasses } from '@/utils';
import { usePdfLayout } from '@/features/PdfLayout';

export type InvoicePdfTotalsProps = ComponentProps<'div'>;

const InvoicePdfTotals = ({ ...props }: InvoicePdfTotalsProps): ReactElement => {
  const { grandSubtotal, grandTotal, totalSavings, hasDiscounts, items } = usePdfLayout(
    ({ state }: { state: { data: RunPreviewInvoiceResponse } }) => ({
      grandSubtotal: state?.data?.output?.invoice?.grandSubtotal ?? 0,
      grandTotal: state?.data?.output?.invoice?.grandTotal ?? 0,
      totalSavings: state?.data?.output?.invoice?.totalSavings ?? 0,
      hasDiscounts: state?.data?.output?.invoice?.hasDiscounts,
      items: state?.data?.output?.items,
    })
  );

  return (
    <div {...props} className={getClasses('InvoicePdf-Totals', props.className)}>
      <Table>
        <InvoicePdfTotalRow name="Grand Sub Total" total={grandSubtotal} />
        {items?.map?.(
          ({ id, name, total = 0 }, index): ReactElement => (
            <InvoicePdfTotalRow key={id || index} name={name} total={total} />
          )
        )}
        <InvoicePdfTotalRow name="Grand Total" isGrand total={grandTotal} />
        {hasDiscounts === 1 && <InvoicePdfTotalRow name="Total Savings" isTotalSaving total={totalSavings} />}
      </Table>
    </div>
  );
};

export default InvoicePdfTotals;
